export enum AppEvents {
  NETWORK_ERROR = 'network-error',
  UNAUTHENTICATED = 'unauthenticated',
}
